module.exports = __webpack_public_path__ + "static/background-our-models-f56508d98af79a71e42c10a96b906266.jpg";